<template>
  <div
    class="pagePicker"
    v-click-outside="closeMenu"
    @keydown="navigatePages"
    tabindex="0"
  >
    <div @click="toggleMenu" class="selected-text heb-text">
      {{ innergetSelectedPage }}
    </div>
    <span @click="toggleMenu" class="mef-font-default mef-font dropdown-icon"
      >p</span
    >
    <div
      ref="pagesMenu"
      class="option-items-container"
      :class="{ 'open-menu': showMenu }"
    >
      <div
        v-if="showPagePreview && pagePreviewType == 'full'"
        class="pageImage"
      >
        <headerItem
          v-if="showPageHeader"
          :currentHeaderData="currentHeaderData"
          :book="book"
          :full="true"
          @setHeight="setHeight"
          :byPos="false"
        />
        <div class="preview-txt" v-else>
          {{ $t("pagesPicker.previewPlaceHolder") }}
        </div>
      </div>
      <div class="inner-pages-container">
        <div class="flex-row container">
          <div class="flex-row config-container">
            <baseToggleSwitch
              @toggle="toggleShowPagePreview"
              @click.self.stop
              class="left-icon"
              :checked="showPagePreview"
              v-show="true"
            />
            <div class="switchLbl">{{ $t("pagesPicker.preview") }}</div>
          </div>
          <div v-if="showPagePreview" class="flex-row">
            <span
              v-show="pagePreviewType == 'full'"
              class="prev-type-icon font-icon check-icon"
              >A</span
            >
            <label
              :class="{ checked: pagePreviewType == 'full' }"
              @click="setPreviewPageType('full')"
            >
              {{ $t("pagesPicker.page") }}
            </label>
            <span
              v-show="pagePreviewType != 'full'"
              class="font-icon check-icon prev-type-icon"
              >A</span
            >
            <label
              :class="{ checked: pagePreviewType != 'full' }"
              @click="setPreviewPageType('header')"
            >
              {{ $t("pagesPicker.header") }}
            </label>
          </div>
        </div>
        <div
          ref="pagesMenuInner"
          class="option-items"
          :class="{ 'mef-open-menu': showMenu }"
        >
          <div
            class="option-item-general"
            :class="{
              'option-item': page && page.title != '',
              'mef-page': isMefPage(page.number),
            }"
            v-for="(page, index) in getBookListPages"
            :key="index"
            :ref="'page_' + page.number"
            @mouseleave="hideHeader"
            @mouseenter="showHeader(page.number)"
          >
            <span
              class="label-option"
              :class="{
                active: currentPage == (page ? page.number : -1),
                'visited-page': isPageVisited(page.number),
                'recent-page': isPageRecent(page.number),
              }"
              @click.stop="setPageNumber(page)"
            >
              {{ page ? page.title : "" }}
            </span>
          </div>
        </div>
        <div
          v-if="showPagePreview && pagePreviewType == 'header'"
          ref="headerContainer"
          class="page-header"
        >
          <headerItem
            v-if="showPageHeader"
            :currentHeaderData="currentHeaderData"
            :book="book"
            :full="false"
            @setHeight="setHeight"
            :byPos="false"
          />
          <div class="preview-txt" v-else>
            {{ $t("pagesPicker.previewPlaceHolder") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import headerItem from "@/components/book/headerItem.vue";
export default {
  data() {
    return {
      showMenu: false,
      showPageHeader: false,
      currentHeaderData: {},
    };
  },
  props: ["lazy", "selected", "pagedata", "trick", "tabId"],
  components: { headerItem },
  watch: {
    showMenu: function (val) {
      if (val) {
        this.$nextTick(() => {
          scrollToChildIfNotInView(this.$refs[`page_${this.currentPage}`][0]);
        });
      }
    },
  },
  methods: {
    toggleShowPagePreview() {
      const mode = this.showPagePreview ? "off" : "on";
      this.setShowPagePreview(mode);
    },
    setShowPagePreview(value) {
      this.userSettings.setSettings("showPagePreview", value);
      //  this.userSettings.setSettings("showPagePreview", value ? "on" : "off");
    },
    setPreviewPageType(value) {
      this.userSettings.setSettings("pagePreviewType", value);
    },
    setCurrentHeaderData(page) {
      this.currentHeaderData = {
        pageId: this.getBookListPages[page - 1].name,
        top: 0,
        left: 0,
        pos: page - 1,
      };
    },
    setHeight(val) {
      this.$refs.headerContainer.style.height = "150px";
    },
    showHeader(page) {
      this.setCurrentHeaderData(page);
      this.showPageHeader = true;
    },
    hideHeader() {
      this.showPageHeader = false;
    },
    closeMenu() {
      this.showMenu = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      this.$nextTick(() => {
        if (this.showMenu) {
          this.$refs.pagesMenu.style.maxHeight = `${
            (document.body.clientHeight * 2) / 3
          }px`;

          this.$refs.pagesMenu.focus();
        }
      });
    },

    navigatePages(e) {
      const NumLockEnabled = e.getModifierState
        ? e.getModifierState("NumLock")
        : false;
      switch (e.code) {
        case "ArrowRight":
          if (this.currentPage > 1)
            this.setPageNumber({ number: this.currentPage - 1 }, false);
          break;
        case "Numpad6":
          if (!NumLockEnabled && this.currentPage > 1)
            this.setPageNumber({ number: this.currentPage - 1 }, false);
          break;
        case "ArrowLeft":
          if (this.currentPage < this.getBookListPages.length)
            this.setPageNumber({ number: this.currentPage + 1 }, false);
          break;
        case "Numpad4":
          if (
            !NumLockEnabled &&
            this.currentPage < this.getBookListPages.length
          )
            this.setPageNumber({ number: this.currentPage + 1 }, false);
          break;
      }
    },
    setPageNumber(page, closeMenu = true) {
      if (page == -1) return;
      if (closeMenu) this.closeMenu();
      this.$emit("pageselect", page);
    },
    isPageVisited(page) {
      return this.visitedPages.includes(page);
    },
    isMefPage(page) {
      return (
        this.$store.state.tabs[this.tabId].SHAS_SECTION_LIST_ID &&
        !this.tabId.startsWith("win_") &&
        this.mefPagesPositions.includes(page - 1)
      );
      return true;
    },
    isPageRecent(page) {
      return false;

      let a = this.recentPages.find((p) => p == page);
      return a;
    },
  },
  computed: {
    ...mapGetters("mefShas", ["getBookPages"]),
    PagePreviewMode: {
      get() {
        return this.userSettings.settings.showPagePreview || "on";
      },
      set(value) {
        this.setShowPagePreview(value);
      },
    },
    PagePreviewType: {
      get() {
        return this.userSettings.settings.pagePreviewType || "full";
      },
      set(value) {
        this.setPreviewPageType(value);
      },
    },
    showPagePreview() {
      return this.userSettings.settings.showPagePreview != "off";
    },
    pagePreviewType() {
      return this.userSettings.settings.pagePreviewType || "full";
    },
    mefPagesPositions() {
      return this.getBookPages.flatMap((p) => [p.number, p.number + 1]);
    },
    recentPages() {
      if (parseInt(this.otzarVersion) < 22) return [];

      const arr = this.$store.state.tabs[this.tabId].allRecentPages || [];
      arr.sort((a, b) => b.sticky - a.sticky);
      return arr.slice(0, 5).map((r) => r.position);
    },
    visitedPages() {
      return this.$store.state.books.visitedPages[this.book] || [];
    },
    getBookListPages() {
      let pages = this.$store.state.tabs[this.tabId].pages.map((p, i) => {
        if (p.empty) p.position = 0;
        return p;
      });
      let pos = 1;
      pages.forEach((p) => {
        if (p.position > 0) {
          if (p.originPosition == undefined) p.originPosition = p.position;
          p.position = pos;
          pos++;
        }
      });
      return pages
        .filter((p) => !p.empty)
        .map((p) => {
          return {
            title: p.pagedata[0]?.letter
              ? p.pagedata[0].letter.replace(/יה/g, "טו").replace(/יו/g, "טז")
              : p.position,
            number: p.position,
            name: p.name,
          };
        });
    },
    currentPage() {
      return this.$store.state.tabs[this.tabId].page;
    },
    innergetSelectedPage() {
      return this.getBookListPages[this.currentPage - 1]?.title || "";
    },
    book() {
      return this.$store.state.tabs[this.tabId].book;
    },
  },
};

function scrollToChildIfNotInView(childElement) {
  const parentElement = childElement.parentElement;
  const childRect = childElement.getBoundingClientRect();
  const parentRect = parentElement.getBoundingClientRect();

  // Check if child is within parent's view
  const isInView =
    childRect.top >= parentRect.top && childRect.bottom <= parentRect.bottom;

  // If not in view, adjust scrollTop of the parent element
  if (!isInView) {
    const scrollOffset = childElement.offsetTop - parentElement.offsetTop;
    parentElement.scroll({
      top: scrollOffset,
      behavior: "smooth", // Optional: smooth scrolling
    });
  }
}
</script>

<style scoped>
.left-icon {
  padding-top: 4px;
  padding-right: 10px;
}
.switchLbl {
  padding-right: 5px;
  color: var(--custom-color1);
}
.pagePicker {
  font-size: 12px;
  display: flex;
  text-align: right;
  width: auto;
  box-sizing: border-box;
  position: relative;
  /* justify-content: center; */
  align-items: center;
}
.selected-text {
  width: 40px;
  padding-right: 6px;
}
.dropdown-icon {
  width: 13px;
  line-height: 14px;
  margin-left: 5px;
}
.shadow {
  /*  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);   */
}
.option-items-container {
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  max-height: 400px;
  display: none;
  position: absolute;
  z-index: 4;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  left: 0px;
  top: 100%;
  width: auto;
  flex-direction: row;
  overflow: hidden;
}
.option-items {
  max-width: 514px;
  display: none;
  /*flex: 1; */
  flex-direction: row;
  box-shadow: none !important;
  flex-wrap: wrap;
}
.mef-open-menu {
  display: -webkit-box;
  overflow: auto;
}
.open-menu {
  display: flex;
}
.option-item {
  height: 30px;
  width: 50px;
  align-self: flex-start;
  border-left: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
  text-align: center;
  display: table;
}
.option-item-general {
  height: 30px;
  width: 50px;
}
.label-option {
  display: table-cell;
  vertical-align: middle;
}
.label-option:hover {
  background-color: #dedede;
}
.active {
  background-color: #dedede;
}
.visited-page {
  border: 1px solid var(--custom-color1) !important;
}
.recent-page {
  border: 1.5px solid var(--custom-color2) !important;
}
.mef-page {
  background-color: var(--custom-color5) !important;
  border-color: #e0e0e0 !important;
}
.pageImage {
  width: 350px;
  border-left: solid 1px #f5f5f5;
  background-color: #f1f1f1;
  padding: 2px;
}
.inner-pages-container {
  display: flex;
  flex-direction: column;
}
.page-header {
  height: 70px;
  background-color: #f1f1f1;
  padding: 2px;
}
.container {
  justify-content: space-between;
  padding-top: 5px;
  background-color: #f1f1f1;
}
.prev-type-icon {
  color: var(--custom-color1);
  font-family: otzar-new;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  padding-left: 3px;
}
.checked {
  color: var(--custom-color1);
}
.preview-txt {
  color: var(--custom-color1);
  display: flex;
  justify-content: center; /* Centers horizontally */
  align-items: center; /* Centers vertically */
  height: 100%;
}
</style>
